import React, { useRef, useState } from "react";
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  ThemingProps,
} from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

interface ISearchInput {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  size?: ThemingProps["size"];
}

export function SearchInput({ onChange, size = "md" }: ISearchInput) {
  // const [state, setState] = useState("");
  // const inputRef = useRef<any>();

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    // setState(e.target.value);
    onChange(e);
  }

  return (
    <InputGroup w="auto" size={size}>
      {/* {state ? (
        <InputRightElement
          children={
            <IconButton
              aria-label="cancel"
              icon={<MdCancel />}
              color="gray.300"
              variant="ghost"
              onClick={() => {
                setState("");
              }}
            />
          }
        />
      ) : ( */}
      <InputRightElement
        pointerEvents="none"
        children={<Icon as={FaSearch} boxSize="1em" color="gray.300" />}
      />
      {/* )} */}

      <Input
        placeholder="Search Here"
        background="white"
        w="200px"
        // value={state}
        // ref={inputRef}
        onChange={(e) => handleInputChange(e)}
      />
    </InputGroup>
  );
}
